import React from 'react';

const procurementImages = [
  'Procurement 1.jpg',
  'Procurement 2.png',
  'Procurement 3.jpg',
  'Procurement 4.jpeg',
  'Procurement 5.jpg',
  'Procurement 6.jpg',
];

interface SlidingImageBackdropProps {
  variant: 'dashboard' | 'public';
}

const SlidingImageBackdrop: React.FC<SlidingImageBackdropProps> = ({ variant }) => {
  return (
    <div
      className={`sliding-image-backdrop sliding-image-backdrop--${variant}`}
      aria-hidden="true"
    >
      {procurementImages.map((imageName, index) => {
        const imagePath = `${process.env.PUBLIC_URL}/images/${encodeURIComponent(imageName)}`;
        return (
          <div
            key={imageName}
            className="sliding-image-backdrop__slide"
            style={{
              backgroundImage: `url("${imagePath}")`,
              animationDelay: `${index * 6}s`,
            }}
          />
        );
      })}
      <div className="sliding-image-backdrop__veil" />
    </div>
  );
};

export default SlidingImageBackdrop;
